(function(){
  var STAR='<svg viewBox="0 0 24 24" aria-hidden="true" class="%c"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z"/></svg>';
  function stars(n){var s='';for(var i=1;i<=5;i++){s+=STAR.replace('%c',i<=n?'on':(i-0.5<=n?'half':''));}return s;}
  function money(cents, cur){
    try{return new Intl.NumberFormat('en-AU',{style:'currency',currency:cur||'AUD'}).format(cents/100);}catch(e){return '$'+(cents/100).toFixed(2);}
  }
  function addBusinessDays(d, n){
    var r=new Date(d.getTime());var added=0;
    while(added<n){r.setDate(r.getDate()+1);var w=r.getDay();if(w!==0&&w!==6)added++;}
    return r;
  }
  function fmt(d){return d.toLocaleDateString('en-AU',{weekday:'short',day:'numeric',month:'short'});}
  function fmtShort(d){return d.toLocaleDateString('en-AU',{day:'numeric',month:'short'});}

  function initDates(root){
    root.querySelectorAll('[data-mm-ship]').forEach(function(el){
      var now=new Date();
      var dmin=parseInt(el.dataset.dispatch||'2',10);
      var tmin=parseInt(el.dataset.transitMin||'6',10);
      var tmax=parseInt(el.dataset.transitMax||'12',10);
      var dispatch=addBusinessDays(now,dmin);
      var a=addBusinessDays(dispatch,tmin), b=addBusinessDays(dispatch,tmax);
      var q=function(s){return el.querySelector(s);};
      if(q('[data-d="today"]'))q('[data-d="today"]').textContent=fmt(now);
      if(q('[data-d="dispatch"]'))q('[data-d="dispatch"]').textContent=fmt(dispatch);
      if(q('[data-d="deliver"]'))q('[data-d="deliver"]').textContent=fmtShort(a)+' – '+fmtShort(b);
    });
  }

  function initProduct(root){
    var dataEl=root.querySelector('[data-mm-variants]');
    if(!dataEl)return;
    var variants=JSON.parse(dataEl.textContent);
    var revEl=root.querySelector('[data-mm-reviews]');
    var reviews=[];
    try{reviews=revEl?JSON.parse(revEl.textContent):[];}catch(e){reviews=[];}
    // photo reviews first, then highest rating, then longest
    reviews.sort(function(a,b){return ((b.ph&&b.ph.length?1:0)-(a.ph&&a.ph.length?1:0))||(b.r-a.r)||((b.b||'').length-(a.b||'').length);});
    var snip=root.querySelector('[data-mm-snip]');
    var snipTimer=null, snipList=[], snipI=0, snipKey=null;
    var cur=root.dataset.currency||'AUD';
    var form=root.querySelector('form[data-mm-form]');
    var idInput=form.querySelector('input[name="id"]');
    var gal=root.querySelector('[data-mm-gal]');
    var thumbs=root.querySelectorAll('[data-mm-thumb]');
    var dots=root.querySelectorAll('[data-mm-dot]');
    var sticky=document.querySelector('[data-mm-sticky="'+root.dataset.section+'"]');

    function selected(){
      var opts=[];
      root.querySelectorAll('[data-opt-index]').forEach(function(g){
        var i=parseInt(g.dataset.optIndex,10);
        var c=g.querySelector('input:checked');
        opts[i]=c?c.value:null;
      });
      return opts;
    }
    function find(opts){
      return variants.find(function(v){return v.options.every(function(o,i){return opts[i]==null||opts[i]===o;});});
    }
    function goTo(i){
      if(!gal)return;
      var slide=gal.children[i];if(!slide)return;
      gal.scrollTo({left:slide.offsetLeft-gal.offsetLeft,behavior:'smooth'});
    }
    function mark(i){
      thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i);});
      dots.forEach(function(t,k){t.classList.toggle('is-on',k===i);});
    }
    if(gal){
      var tick=null;
      gal.addEventListener('scroll',function(){clearTimeout(tick);tick=setTimeout(function(){var i=Math.round(gal.scrollLeft/gal.clientWidth);mark(i);},60);},{passive:true});
      thumbs.forEach(function(t,k){t.addEventListener('click',function(){goTo(k);mark(k);});});
    }

    function showSnip(){
      if(!snip||!snipList.length)return;
      var r=snipList[snipI%snipList.length];
      var card=snip.querySelector('[data-mm-snip-card]');
      card.classList.add('is-fade');
      setTimeout(function(){
        snip.querySelector('[data-s-stars]').innerHTML=stars(r.r);
        snip.querySelector('[data-s-body]').textContent='“'+(r.t?r.t+' — ':'')+r.b+'”';
        snip.querySelector('[data-s-name]').textContent=r.n;
        snip.querySelector('[data-s-meta]').textContent=[r.l,r.o?('bought '+r.o):''].filter(Boolean).map(function(s){return '· '+s;}).join(' ');
        snip.querySelector('[data-s-ver]').classList.toggle('mm-hide',!r.v);
        snip.querySelector('[data-s-src]').classList.toggle('mm-hide',!r.x);
        var ph=snip.querySelector('[data-s-ph]');
        ph.innerHTML='';
        if(r.ph&&r.ph.length){r.ph.slice(0,3).forEach(function(u){var im=document.createElement('img');im.src=u;im.alt='Customer photo';im.loading='lazy';ph.appendChild(im);});ph.classList.remove('mm-hide');}else{ph.classList.add('mm-hide');}
        var c=snip.querySelector('[data-s-count]');
        c.textContent=snipList.length>1?((snipI%snipList.length)+1)+' / '+snipList.length:'';
        card.classList.remove('is-fade');
      },180);
    }
    function setSnip(key){
      if(!snip||!reviews.length)return;
      if(key===snipKey&&snipList.length)return;
      snipKey=key;
      var m=reviews.filter(function(r){return key&&r.o===key;});
      var rest=reviews.filter(function(r){return !(key&&r.o===key);});
      snipList=m.concat(rest);
      snipI=0;showSnip();
      clearInterval(snipTimer);
      if(snipList.length>1)snipTimer=setInterval(function(){snipI++;showSnip();},6500);
    }

    function update(fromColour){
      var opts=selected();
      var v=find(opts);
      if(!v)return;
      idInput.value=v.id;
      root.querySelectorAll('[data-mm-price]').forEach(function(e){e.textContent=money(v.price,cur);});
      root.querySelectorAll('[data-mm-was]').forEach(function(e){
        if(v.compare_at_price&&v.compare_at_price>v.price){e.textContent=money(v.compare_at_price,cur);e.classList.remove('mm-hide');}else{e.classList.add('mm-hide');}
      });
      root.querySelectorAll('[data-mm-save]').forEach(function(e){
        if(v.compare_at_price&&v.compare_at_price>v.price){e.textContent='Save '+money(v.compare_at_price-v.price,cur);e.classList.remove('mm-hide');}else{e.classList.add('mm-hide');}
      });
      root.querySelectorAll('[data-mm-atc-price]').forEach(function(e){e.textContent=money(v.price,cur);});
      var btn=form.querySelector('[type="submit"]');
      if(btn){btn.disabled=!v.available;}
      root.querySelectorAll('[data-mm-pack]').forEach(function(card){
        var i=parseInt(card.dataset.optIdx,10);
        var o=opts.slice();o[i]=card.dataset.mmPack;
        var pv=find(o);
        var inp=card.querySelector('input');
        card.classList.toggle('is-on',inp.checked);
        if(pv){
          var b=card.querySelector('[data-pp]');if(b)b.textContent=money(pv.price,cur);
          var s=card.querySelector('[data-pw]');if(s){if(pv.compare_at_price>pv.price){s.textContent=money(pv.compare_at_price,cur);s.classList.remove('mm-hide');}else s.classList.add('mm-hide');}
        }
      });
      var sg=root.querySelector('[data-snip-opt]');
      if(sg){var si=parseInt(sg.dataset.optIndex,10);setSnip(opts[si]);}else{setSnip(null);}
      if(fromColour&&v.media_index!=null){goTo(v.media_index);mark(v.media_index);}
      if(sticky){
        var sp=sticky.querySelector('[data-mm-price]');if(sp)sp.textContent=money(v.price,cur);
        var st=sticky.querySelector('[data-mm-vt]');if(st)st.textContent=v.title;
        if(v.image){var sim=sticky.querySelector('img');if(sim)sim.src=v.image;}
      }
      if(root.dataset.updateUrl==='true'&&window.history.replaceState){
        var url=new URL(window.location.href);url.searchParams.set('variant',v.id);window.history.replaceState({},'',url.toString());
      }
    }
    root.addEventListener('change',function(e){
      if(e.target.matches('[data-opt-index] input')){
        var g=e.target.closest('[data-opt-index]');
        update(g&&g.hasAttribute('data-colour'));
      }
    });
    update(false);

    if(sticky){
      var atc=root.querySelector('[data-mm-atc]');
      sticky.querySelector('[data-mm-sticky-btn]').addEventListener('click',function(){
        if(form.requestSubmit)form.requestSubmit();else form.submit();
      });
      if('IntersectionObserver' in window&&atc){
        new IntersectionObserver(function(en){
          en.forEach(function(x){
            var past=x.boundingClientRect.top<0;
            sticky.classList.toggle('is-on',!x.isIntersecting&&past);
          });
        }).observe(atc);
      }
    }
  }

  function boot(){
    document.querySelectorAll('[data-mm-product]').forEach(initProduct);
    initDates(document);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
